import { GateRamp, type GateRampConfig } from './gate-ramp';

/**
 * Upgrade 15 — kit-block factories. Stripe Elements analog: instead of
 * the full widget (where the user picks buy/sell/swap), each factory
 * returns a `GateRamp` pre-locked to a single flow. The iframe-app
 * hides the tab strip and forces the chosen view.
 *
 * Use when you've already collected the user's intent on your own
 * surface (e.g. a "Buy crypto" button) and want the widget to pick up
 * at the right step.
 *
 *   import { createGateOnRamp } from '@0gate/gate-js';
 *
 *   const ramp = createGateOnRamp({
 *     publishableKey: 'pk_test_...',
 *     clientSecret: session.client_secret,
 *   });
 *   await ramp.mount('#buy-crypto');
 *
 * The session itself can also be created with `flow` set on your
 * server — that's the canonical place. The factory's `flow` is a
 * local assertion / fallback for partners not yet using sessions.
 */

export type GateRampConfigWithoutFlow = Omit<GateRampConfig, 'flow'>;

export function createGateOnRamp(config: GateRampConfigWithoutFlow): GateRamp {
   return new GateRamp({ ...config, flow: 'on_ramp' });
}

export function createGateOffRamp(config: GateRampConfigWithoutFlow): GateRamp {
   return new GateRamp({ ...config, flow: 'off_ramp' });
}

export function createGateSwap(config: GateRampConfigWithoutFlow): GateRamp {
   return new GateRamp({ ...config, flow: 'swap' });
}
